<template>
  <div class="search-item-container search-item-youtube">
    <!-- HEADER -->
    <div class="search-item-header">
      <div class="search-item-title">
        <h4>
          <a :href="item.liveUrl" target="_blank">{{ item.title }}</a>
        </h4>
      </div>
      <div class="search-item-link">
        <a :href="item.liveUrl" target="_blank">{{ item.displayUrl }}</a>
      </div>
    </div>

    <!-- CONTENT -->
    <div class="search-item-content">
      <div class="search-item-image-wrapper">
        <img
          :src="item.metaData.image"
          :alt="'Thumbnail for ' + item.title"
          v-if="item.metaData && item.metaData.image"
        />
        <div class="youtube-player-icon" v-on:click="openPlayer">
          <i class="fas fa-play fa-fw"></i>
        </div>
      </div>
      <span class="search-item-date">{{ item.date }} </span>{{ item.summary }}
    </div>

    <search-youtube-player
      :item="item"
      :isOpen="showPlayer"
      @closed="closePlayer"
    ></search-youtube-player>
  </div>
</template>

<script>
import SearchYoutubePlayer from "./searchYoutubePlayer";

export default {
  name: "SearchItemYoutube",
  components: { SearchYoutubePlayer },
  data() {
    return {
      showPlayer: false,
    };
  },
  computed: {
    collection() {
      return this.item.collection;
    },
  },
  props: {
    item: {
      type: Object,
    },
  },

  methods: {
    openPlayer() {
      this.showPlayer = true;
    },
    closePlayer() {
      this.showPlayer = false;
    },
  },
};
</script>

<style scoped>
.search-item-content .search-item-image-wrapper {
  position: relative;
}

.search-item-content .search-item-image-wrapper .youtube-player-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  width: 100%;
  height: 100%;
  font-size: 35px;
  color: var(--wwfOrange);
  text-shadow: 3px 3px 8px var(--wwfGrey33);
  background-color: var(--wwfTransparentWhite020);
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// searchItemYoutube.vue?07687595